import { initializeFlash as initializeFlashWithServerData } from '@web/ui-platform/flash/actions'
import type { FlashInitialOptions } from '@web/ui-platform/flash/types'

import initialOptions from 'lib/initial_options'

export function initializeFlash() {
  return initializeFlashWithServerData(initialOptions<FlashInitialOptions>().flash)
}
